export default __webpack_public_path__ + "static/media/IMG_5372.767e6d0d.JPG";